export default {
  'emailTemplates.mailFormat': 'Formato de Correo',
  'emailTemplates.seeAdvancedEdition': 'ver Edición Avanzada',
  'emailTemplates.hideAdvancedEditing': 'Ocultar Edición Avanzada',
  'emailTemplates.form.subject': 'Asunto',
  'emailTemplates.form.fromName': 'Nombre Remitente',
  'emailTemplates.form.htmlContent': 'Contenido HTML',
};
